import { useNavigate } from 'react-router-dom'

export const TOKEN_GENERATOR_URL = '/utils/token/:type'

export const useGoToTokenGenerator = () => {
  const navigate = useNavigate()

  return {
    go: (type: string) => {
      navigate(TOKEN_GENERATOR_URL.replace(':type', type))
    }
  }
}
